import { fetchAuthSession } from "@aws-amplify/auth";
import { configureAuth } from "../auth/authConfig";
import { isAdminSession } from "../auth/adminAuthConfig";
import { withSessionLock } from "../auth/sessionQueue";
const base = (process.env.REACT_APP_ADMIN_BLOG_API || "").replace(/\/$/, "");
export const blogConfigured = () => Boolean(base);
export async function blogRequest({ admin = false, action, post, id, cursor, signal } = {}) {
  if (!base) throw new Error("The journal is not connected yet.");
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener("abort", abort);
  if (signal?.aborted) controller.abort();
  let timer;
  const request = async () => {
    const headers = {};
    if (admin) {
      headers.Authorization = await withSessionLock(async () => {
        configureAuth("admin"); const session = await fetchAuthSession();
        if (!isAdminSession(session)) throw new Error("Please sign in to the admin portal again.");
        return session.tokens.idToken.toString();
      });
    }
    if (controller.signal.aborted) throw new Error('Timeout');
    const query = new URLSearchParams();
    if (id) query.set("id", id); if (cursor) query.set("cursor", cursor);
    if (action) headers['Content-Type'] = 'application/json';
    const response = await fetch(`${base}/${admin ? 'posts' : 'public'}?${query}`, { method: action ? 'POST' : 'GET', headers, ...(action ? {body: JSON.stringify({...post, action})} : {}), signal: controller.signal });
    const data = await response.json();
    if (controller.signal.aborted) throw new Error('Timeout');
    if (!response.ok) throw new Error(response.status === 401 || response.status === 403 ? 'Please sign in to the admin portal again.' : response.status === 409 ? 'This post changed. Reload before editing it again.' : 'We could not complete that request. Please retry.');
    if (!data || (action ? action === 'delete' ? data.deleted !== true : !data.post?.id : id ? !data.post?.id : !Array.isArray(data.posts))) throw new Error('The journal returned an incomplete response. Reload before continuing.');
    return data;
  };
  try {
    return await Promise.race([request(), new Promise((resolve, reject) => {timer = setTimeout(() => {abort(); reject(new Error('Timeout'));}, 20000);})]);
  } catch (error) {
    if (controller.signal.aborted) throw new Error(action ? 'We could not confirm the change. Reload the journal before trying again.' : 'The journal took too long to respond. Please retry.');
    throw error;
  } finally { clearTimeout(timer); signal?.removeEventListener('abort', abort); }
}
